<template>
	<div  class="filters-box-row">
		<div class="filters-container">
			<div class="time-box">
				<el-select v-model="datetype" class="select-box" size='mini'>
					<el-option :value='0' label="下单时间"></el-option>
					<el-option :value='1' label="收款时间"></el-option>
					<el-option :value='2' label="收货时间"></el-option>
				</el-select>
				<el-date-picker
					v-model="dateValue"
					:unlink-panels='true'
					:default-time="['00:00:00', '23:59:59']"
					format='yyyy-MM-dd HH:mm'
					size="mini"
					class="time-picker"
					type="datetimerange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format='yyyy-MM-dd HH:mm:ss'>
				</el-date-picker>
			</div>
			<div class="input-box">
				<span>商品名称：</span>
				<el-input
					v-model="productname"
					placeholder="请输入商品名称"
					size="mini"
					@keyup.enter.native="search">
				</el-input>
			</div>
			<div class="input-box">
				<span>订单编号：</span>
				<el-input
					v-model="ordernumber"
					placeholder="请输入订单编号"
					size="mini"
					@keyup.enter.native="search">
				</el-input>
			</div>
			<el-button size='mini' type="primary" class="btn fx-btn" @click="search">查询</el-button>
			<el-button size="mini" plain class="btn fx-btn" @click="clear">清空</el-button>
			<el-button size="small" type="text" style="margin-right:20px" class="btn" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"/>
			</el-button>
		</div>
		<div class="filters-container" v-if="!collapse" >
			<div class="input-box">
				<span>收款状态：</span>
				<el-select v-model="paymentstatus" class="filter-input" size='mini'>
					<el-option :value='-1' label="全部"></el-option>
					<el-option :value='1' label="已收款"></el-option>
					<el-option :value='0' label="收款中"></el-option>
					<el-option :value='2' label="待收款"></el-option>
				</el-select>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'search',
	data () {
		return {
			ordernumber: '',
			productname: '',
			paymentstatus: -1,
			datetype: 0,
			collapse: false,
			dateValue: []
		}
	},
	created () {
		this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
	},
	methods: {
		handleCollapse () {
			this.collapse = !this.collapse
		},
		checkTime () {
			if (this.dateValue === null || this.dateValue === []) {
				this.$message.error('请选择正确时间范围！')
				return false
			}
			var begintime = this.dateValue[0]
			var endtime = this.dateValue[1]
			// 判断时间跨度是否大于6个月
			var arr1 = begintime.split('-')
			var arr2 = endtime.split('-')
			arr1[1] = parseInt(arr1[1])
			arr1[2] = parseInt(arr1[2])
			arr2[1] = parseInt(arr2[1])
			arr2[2] = parseInt(arr2[2])
			var flag = true
			if (arr1[0] === arr2[0]) { // 同年
				if (arr2[1] - arr1[1] > 6) { // 月间隔超过6个月
					flag = false
				} else if (arr2[1] - arr1[1] === 6) { // 月相隔6个月，比较日
					if (arr2[2] > arr1[2]) { // 结束日期的日大于开始日期的日
						flag = false
					}
				}
			} else { // 不同年
				if (arr2[0] - arr1[0] > 1) {
					flag = false
				} else if (arr2[0] - arr1[0] === 1) {
					if (arr1[1] + 6 - arr2[1] < 12) { // 月相隔大于6个月
						flag = false
					} else if (arr1[1] + 6 - arr2[1] === 12) { // 月相隔6个月，比较日
						if (arr2[2] > arr1[2]) { // 结束日期的日大于开始日期的日
							flag = false
						}
					}
				}
			}
			if (!flag) {
				this.$message.error('时间范围不得超过6个月！')
				return false
			}
			return true
		},
		search () {
			if (this.checkTime()) {
				this.$emit('handleSearch', { dateValue: this.dateValue, ordernumber: this.ordernumber, productname: this.productname, datetype: this.datetype, paymentstatus: this.paymentstatus })
			}
		},
		clear () {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			this.ordernumber = ''
			this.productname = ''
			this.paymentstatus = -1
			this.datetype = 0
			this.search()
		}
	}
}
</script>

<style lang="stylus" scoped>
.filters-box-row {
	display: flex;
	flex-direction column
	padding: 0;
	width :100%;
	line-height :50px;
	min-width :600px;
	box-sizing: border-box；
	.filters-container {
		display flex
		flex: 1
		height: 50px
		.input-box {
			width: 250px
			span {
				margin-right: 10px
			}
			.el-input{
				width :150px
			}
			.filter-input {
				width:150px
			}
		}
		.time-box {
			display flex
			width: 440px
			margin-right 10px
			.select-box{
				width :120px;
				margin-right 10px
			}
			.time-picker{
				width :320px
				margin-top :10px
			}
			.filter-input {
				flex: 1
			}
		}
		.btn {
			height: 32px
			margin-top: 10px
			margin-left 20px
		}
	}
}
</style>
